import { useState } from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import { deleteMonitor, putMonitor } from 'redux/actions/jobsActions';
import { useSelector } from 'react-redux';
import selectors from 'redux/selectors/selectors';
import { Dropdown } from '../../shared/components/dropdown/dropdown';
import { DropdownItem } from '../../shared/components/dropdown/dropdown-item';
import { RxCross1 } from 'react-icons/rx';
import { PiPlayPauseFill, PiTrashLight } from 'react-icons/pi';
import { CgSpinner } from 'react-icons/cg';

const Container = styled.div`
  position: relative;
  display: flex;
  border: solid 1px #06abc1;
  width: 100%;
  border-radius: 12px;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  z-index: 100;
`;

const DropdownItemContent = styled.div`
  height: 16px;
  display: flex;
  align-items: center;
  width: 100%;
`;

const Value = styled.div`
  font-weight: 700;
  width: 100%;
  color: #fff;
  text-align: center;
`;

const ConfirmAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const ConfirmButtons = styled.div`
  display: flex;
  gap: 8px;
`;

const ActionButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 4px;

  &:hover {
    color: #06abc1;
  }
`;

export function SiteActionButtonFeature() {
  const monitor = useSelector(selectors.httpMonitorDetails);

  const [loading, setLoading] = useState(false);
  const [deleteConfirmVisible, setDeleteConfirmVisible] = useState(false);
  const [pauseConfirmVisible, setPauseConfirmVisible] = useState(false);
  const isPaused = monitor?.state === 'paused';

  const navigate = useNavigate();

  const openModalEdit = () => {
    navigate('edit');
  };

  const handleDeleteAction = () => {
    setLoading(true);
    deleteMonitor(monitor.id, () => {
      setDeleteConfirmVisible(false);
      setLoading(false);
      navigate(`/dashboard`);
    });
  };

  const togglePauseConfirm = () => {
    setPauseConfirmVisible(!pauseConfirmVisible);
  };

  const toggleDeleteConfirm = () => {
    setDeleteConfirmVisible(!deleteConfirmVisible);
  };

  const handlePauseAction = () => {
    setLoading(true);
    putMonitor(monitor.id, {
      ...monitor,
      group_notification_ids: monitor.group_notifications.map((item) => item.id),
      timeout_ms: monitor.timeout_ms / 1000,
      run_interval_seconds: monitor.run_interval_seconds / 60,
      state: isPaused ? 'active' : 'paused',
    })
      .then(() => {
        setPauseConfirmVisible(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getPausedTitle = () => {
    return isPaused ? 'Unpause' : 'Pause';
  };

  return (
    <>
      <Container>
        <Dropdown trigger={<Value>Action</Value>}>
          <DropdownItem>
            <div onClick={openModalEdit}>Edit</div>
          </DropdownItem>
          <DropdownItem>
            <DropdownItemContent>
              {pauseConfirmVisible ? (
                <ConfirmAction>
                  <>
                    <div>{getPausedTitle()}?</div>
                    <ConfirmButtons>
                      <ActionButton onClick={handlePauseAction}>
                        {loading ? (
                          <CgSpinner
                            size={14}
                            color={'#fff'}
                            style={{
                              animation: 'spin 1s linear infinite',
                            }}
                          />
                        ) : (
                          <PiPlayPauseFill
                            size={14}
                            color={'#fff'}
                          />
                        )}
                      </ActionButton>
                      <ActionButton onClick={togglePauseConfirm}>
                        <RxCross1
                          size={14}
                          color={'#fff'}
                        />
                      </ActionButton>
                    </ConfirmButtons>
                  </>
                </ConfirmAction>
              ) : (
                <div
                  style={{
                    width: '100%',
                  }}
                  onClick={togglePauseConfirm}>
                  {getPausedTitle()}
                </div>
              )}
            </DropdownItemContent>
          </DropdownItem>
          <DropdownItem>
            <DropdownItemContent>
              {deleteConfirmVisible ? (
                <ConfirmAction>
                  <>
                    <div>Delete?</div>
                    <ConfirmButtons>
                      <ActionButton onClick={handleDeleteAction}>
                        {loading ? (
                          <CgSpinner
                            size={14}
                            color={'#fff'}
                            style={{
                              animation: 'spin 1s linear infinite',
                            }}
                          />
                        ) : (
                          <PiTrashLight
                            size={14}
                            color={'#fff'}
                          />
                        )}
                      </ActionButton>
                      <ActionButton onClick={toggleDeleteConfirm}>
                        <RxCross1
                          size={14}
                          color={'#fff'}
                        />
                      </ActionButton>
                    </ConfirmButtons>
                  </>
                </ConfirmAction>
              ) : (
                <div
                  style={{ width: '100%' }}
                  onClick={toggleDeleteConfirm}>
                  Delete
                </div>
              )}
            </DropdownItemContent>
          </DropdownItem>
        </Dropdown>
      </Container>
    </>
  );
}
